exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".intl-breadcrumb[data-v-d501c630] {\n  padding: 0.104167rem 0;\n  font-size: 0.088542rem;\n  color: #8a9bb0;\n}\n.intl-breadcrumb a[data-v-d501c630] {\n  color: #1668f4;\n  text-decoration: none;\n}\n.intl-breadcrumb a[data-v-d501c630]:hover {\n  text-decoration: underline;\n}\n.intl-breadcrumb__sep[data-v-d501c630] {\n  margin: 0 0.041667rem;\n  color: #c5cdd6;\n}", ""]);

// exports
